module.exports = __webpack_public_path__ + "img/349.3f01fc41.jpg";